import styled from "styled-components"

export const FormContainer = styled("div")`
  position: relative;
  margin: 0 auto;
  border-width: 1px 0;
  max-width: 660px;
  text-align: center;
`
export const Form = styled.form`
  position: relative;
  transition: opacity 0.1s ease-out;
  opacity: ${props => (props.visible ? 1 : 0)};
  z-index: ${props => (props.visible ? 1 : 0)};
`
export const VisibleBlock = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  transition: opacity 0.1s ease-out;
  opacity: ${props => (props.visible ? 1 : 0)};
  z-index: ${props => (props.visible ? 1 : 0)};
`
